import { render } from "./EinrichtungInformationDialog.vue?vue&type=template&id=318b470c&scoped=true"
import script from "./EinrichtungInformationDialog.vue?vue&type=script&lang=js"
export * from "./EinrichtungInformationDialog.vue?vue&type=script&lang=js"

import "./EinrichtungInformationDialog.vue?vue&type=style&index=0&id=318b470c&lang=stylus&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318b470c"]])

export default __exports__